// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-payouts-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.payouts-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1100px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === STATS GRID === */
.payouts-stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.p-stat-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    display: flex;
    align-items: center;
    gap: 1.25rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
}

.border-emerald {
    border-bottom: 4px solid #10b981;
}

.border-gold {
    border-bottom: 4px solid #f59e0b;
}

.p-stat-icon {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.bg-emerald-light {
    background: #ecfdf5;
}

.bg-gold-light {
    background: #fffbeb;
}

.text-emerald {
    color: #059669;
}

.text-gold {
    color: #d97706;
}

.text-blue {
    color: #2563eb;
}

.bg-red-light {
    background: #fef2f2;
}

.text-red {
    color: #dc2626;
}

.p-stat-info p {
    margin: 0 0 0.25rem 0;
    color: #64748b;
    font-size: 1rem;
    font-weight: 600;
}

.p-stat-info h3 {
    margin: 0;
    font-size: 1.8rem;
    font-weight: 800;
    letter-spacing: -0.5px;
}

/* === CONTROL PANEL (Search & Filter) === */
.payouts-control-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
    background: white;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.admin-search-form {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
    max-width: 500px;
}

.admin-search-input-wrapper {
    display: flex;
    align-items: center;
    flex: 1 1;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 0.75rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.admin-search-input-wrapper:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.admin-search-icon {
    color: #94a3b8;
    flex-shrink: 0;
}

.admin-search-input {
    flex: 1 1;
    border: none;
    background: transparent;
    padding: 0.75rem 0.5rem;
    font-size: 1rem;
    color: #1e293b;
    outline: none;
    min-width: 0;
}

.admin-search-submit-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
}

.admin-search-submit-btn:hover {
    background: #2563eb;
}

/* === CUSTOM DROPDOWN FILTER === */
.payouts-control-panel .filter-wrapper {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    width: 320px;
    max-width: 100%;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    height: auto !important;
}

.filter-icon {
    color: #64748b;
    flex-shrink: 0;
}

.custom-dropdown-container {
    position: relative;
    flex: 1 1;
}

.custom-dropdown-trigger {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.custom-dropdown-trigger:hover {
    border-color: #94a3b8;
}

.custom-dropdown-trigger.open {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.placeholder-text {
    color: #64748b;
    font-size: 0.95rem;
    font-weight: 500;
}

.selected-emp-name {
    font-size: 0.95rem;
    color: #1e293b;
    font-weight: 600;
}

.dropdown-arrow {
    color: #64748b;
    transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
    transform: rotate(180deg);
}

.custom-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    max-height: 250px;
    overflow-y: auto;
    z-index: 50;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.custom-dropdown-item {
    padding: 0.75rem 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s ease;
}

.custom-dropdown-item:last-child {
    border-bottom: none;
}

.custom-dropdown-item:hover {
    background: #f8fafc;
}

.custom-dropdown-item.selected {
    background: #eff6ff;
}

.emp-drop-info h4 {
    margin: 0;
    font-size: 0.95rem;
    color: #1e293b;
}

/* === HIGH DENSITY COMPACT LIST === */
.compact-list-container {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.compact-pay-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 0.75rem 1rem;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.01);
}

.compact-pay-row:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.04);
}

.cp-left {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    flex: 1 1;
    min-width: 0;
}

.cp-avatar {
    height: 38px;
    width: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cp-info {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0;
}

.cp-name {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cp-meta {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.85rem;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cp-dot {
    color: #cbd5e1;
}

.cp-group-text {
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cp-month {
    color: #d97706;
    font-weight: 700;
}

.cp-right {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-shrink: 0;
    margin-left: 1rem;
}

.cp-financials {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.1rem;
}

.cp-pending {
    font-size: 1.15rem;
    font-weight: 800;
    line-height: 1;
}

.cp-paid {
    font-size: 0.75rem;
    color: #94a3b8;
    font-weight: 600;
}

.cp-notify-btn {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
    padding: 0.5rem 0.85rem;
    border-radius: 8px;
    font-weight: 700;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    gap: 0.35rem;
    cursor: pointer;
    transition: 0.2s;
}

.cp-notify-btn:hover:not(:disabled) {
    background: #d1fae5;
}

.cp-notify-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.spinner-micro {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(5, 150, 105, 0.3);
    border-top-color: #059669;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Pagination & Empty States */
.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 4rem 2rem;
    text-align: center;
    font-size: 1.2rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.empty-icon-wrapper {
    height: 80px;
    width: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}

.elder-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    background: white;
    padding: 1rem 1.5rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f1f5f9;
    border: none;
    color: #334155;
    padding: 0.75rem 1.25rem;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #e2e8f0;
    color: #1e293b;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* =========================================
   === CUSTOM DIALOG MODALS ===
   ========================================= */

.admin-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
    animation: fadeInOverlay 0.2s ease-out;
}

@keyframes fadeInOverlay {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.admin-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2.5rem 2rem;
    max-width: 420px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    animation: scaleIn 0.2s ease-out;
}

@keyframes scaleIn {
    from {
        transform: scale(0.95);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.confirm-dialog-card {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.confirm-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.confirm-dialog-card h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 800;
}

.confirm-dialog-card p {
    margin: 0;
    color: #64748b;
    line-height: 1.5;
    font-size: 1.05rem;
}

.modal-actions {
    display: flex;
    gap: 1rem;
}

.modal-actions button {
    flex: 1 1;
}

.btn-success-fill {
    background: #10b981 !important;
    color: white !important;
}

.btn-success-fill:hover:not(:disabled) {
    background: #059669 !important;
}

.btn-danger-fill {
    background: #ef4444 !important;
    color: white !important;
}

.btn-danger-fill:hover:not(:disabled) {
    background: #dc2626 !important;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 950px) {
    .payouts-control-panel {
        flex-direction: column;
        align-items: stretch;
    }

    .admin-search-form {
        max-width: 100%;
    }

    .payouts-control-panel .filter-wrapper {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 768px) {
    .payouts-stats-grid {
        grid-template-columns: 1fr;
    }

    .payouts-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .elder-pagination {
        flex-direction: column;
        gap: 1.5rem;
    }

    .page-btn {
        width: 100%;
        justify-content: center;
    }

    /* Compact Row Mobile Overrides */
    .compact-pay-row {
        padding: 0.75rem;
    }

    .cp-avatar {
        width: 32px;
        height: 32px;
    }

    .cp-name {
        font-size: 1rem;
    }

    .cp-pending {
        font-size: 1.05rem;
    }

    .cp-meta {
        font-size: 0.75rem;
    }

    .cp-right {
        gap: 0.6rem;
        margin-left: 0.5rem;
    }

    /* Hide text on mobile button to save space */
    .remind-txt {
        display: none;
    }

    .cp-notify-btn {
        padding: 0.5rem;
    }

    .admin-modal-card {
        padding: 2rem 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Payouts.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,+CAA+C;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,8BAA8B;AAC9B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;8CAE8C;;AAE9C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,qFAAqF;IACrF,gCAAgC;AACpC;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,kCAAkC;AAClC;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA,iCAAiC;IACjC;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA,6CAA6C;IAC7C;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".admin-payouts-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.payouts-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1100px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === STATS GRID === */\n.payouts-stats-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.p-stat-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n}\n\n.border-emerald {\n    border-bottom: 4px solid #10b981;\n}\n\n.border-gold {\n    border-bottom: 4px solid #f59e0b;\n}\n\n.p-stat-icon {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.bg-emerald-light {\n    background: #ecfdf5;\n}\n\n.bg-gold-light {\n    background: #fffbeb;\n}\n\n.text-emerald {\n    color: #059669;\n}\n\n.text-gold {\n    color: #d97706;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.bg-red-light {\n    background: #fef2f2;\n}\n\n.text-red {\n    color: #dc2626;\n}\n\n.p-stat-info p {\n    margin: 0 0 0.25rem 0;\n    color: #64748b;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.p-stat-info h3 {\n    margin: 0;\n    font-size: 1.8rem;\n    font-weight: 800;\n    letter-spacing: -0.5px;\n}\n\n/* === CONTROL PANEL (Search & Filter) === */\n.payouts-control-panel {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n    background: white;\n    padding: 1rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.admin-search-form {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    max-width: 500px;\n}\n\n.admin-search-input-wrapper {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    background: white;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    padding: 0 0.75rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.admin-search-input-wrapper:focus-within {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.admin-search-icon {\n    color: #94a3b8;\n    flex-shrink: 0;\n}\n\n.admin-search-input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    padding: 0.75rem 0.5rem;\n    font-size: 1rem;\n    color: #1e293b;\n    outline: none;\n    min-width: 0;\n}\n\n.admin-search-submit-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n    flex-shrink: 0;\n}\n\n.admin-search-submit-btn:hover {\n    background: #2563eb;\n}\n\n/* === CUSTOM DROPDOWN FILTER === */\n.payouts-control-panel .filter-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n    width: 320px;\n    max-width: 100%;\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n    height: auto !important;\n}\n\n.filter-icon {\n    color: #64748b;\n    flex-shrink: 0;\n}\n\n.custom-dropdown-container {\n    position: relative;\n    flex: 1;\n}\n\n.custom-dropdown-trigger {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    background: white;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.custom-dropdown-trigger:hover {\n    border-color: #94a3b8;\n}\n\n.custom-dropdown-trigger.open {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.placeholder-text {\n    color: #64748b;\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.selected-emp-name {\n    font-size: 0.95rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.dropdown-arrow {\n    color: #64748b;\n    transition: transform 0.3s ease;\n}\n\n.dropdown-arrow.rotated {\n    transform: rotate(180deg);\n}\n\n.custom-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 50;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-5px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.custom-dropdown-item {\n    padding: 0.75rem 1rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.2s ease;\n}\n\n.custom-dropdown-item:last-child {\n    border-bottom: none;\n}\n\n.custom-dropdown-item:hover {\n    background: #f8fafc;\n}\n\n.custom-dropdown-item.selected {\n    background: #eff6ff;\n}\n\n.emp-drop-info h4 {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #1e293b;\n}\n\n/* === HIGH DENSITY COMPACT LIST === */\n.compact-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n}\n\n.compact-pay-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 0.75rem 1rem;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.01);\n}\n\n.compact-pay-row:hover {\n    border-color: #cbd5e1;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.04);\n}\n\n.cp-left {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.cp-avatar {\n    height: 38px;\n    width: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.cp-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    min-width: 0;\n}\n\n.cp-name {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #1e293b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cp-meta {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.85rem;\n    color: #64748b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cp-dot {\n    color: #cbd5e1;\n}\n\n.cp-group-text {\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.cp-month {\n    color: #d97706;\n    font-weight: 700;\n}\n\n.cp-right {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    flex-shrink: 0;\n    margin-left: 1rem;\n}\n\n.cp-financials {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.1rem;\n}\n\n.cp-pending {\n    font-size: 1.15rem;\n    font-weight: 800;\n    line-height: 1;\n}\n\n.cp-paid {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    font-weight: 600;\n}\n\n.cp-notify-btn {\n    background: #ecfdf5;\n    color: #059669;\n    border: 1px solid #a7f3d0;\n    padding: 0.5rem 0.85rem;\n    border-radius: 8px;\n    font-weight: 700;\n    font-size: 0.85rem;\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.cp-notify-btn:hover:not(:disabled) {\n    background: #d1fae5;\n}\n\n.cp-notify-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.spinner-micro {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(5, 150, 105, 0.3);\n    border-top-color: #059669;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Pagination & Empty States */\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 4rem 2rem;\n    text-align: center;\n    font-size: 1.2rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.empty-icon-wrapper {\n    height: 80px;\n    width: 80px;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n\n.elder-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    background: white;\n    padding: 1rem 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #f1f5f9;\n    border: none;\n    color: #334155;\n    padding: 0.75rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* =========================================\n   === CUSTOM DIALOG MODALS ===\n   ========================================= */\n\n.admin-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n    animation: fadeInOverlay 0.2s ease-out;\n}\n\n@keyframes fadeInOverlay {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.admin-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2.5rem 2rem;\n    max-width: 420px;\n    width: 100%;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    animation: scaleIn 0.2s ease-out;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.confirm-dialog-card {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.confirm-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.confirm-dialog-card h3 {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.confirm-dialog-card p {\n    margin: 0;\n    color: #64748b;\n    line-height: 1.5;\n    font-size: 1.05rem;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.modal-actions button {\n    flex: 1;\n}\n\n.btn-success-fill {\n    background: #10b981 !important;\n    color: white !important;\n}\n\n.btn-success-fill:hover:not(:disabled) {\n    background: #059669 !important;\n}\n\n.btn-danger-fill {\n    background: #ef4444 !important;\n    color: white !important;\n}\n\n.btn-danger-fill:hover:not(:disabled) {\n    background: #dc2626 !important;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 950px) {\n    .payouts-control-panel {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .admin-search-form {\n        max-width: 100%;\n    }\n\n    .payouts-control-panel .filter-wrapper {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 768px) {\n    .payouts-stats-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .payouts-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .elder-pagination {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    .page-btn {\n        width: 100%;\n        justify-content: center;\n    }\n\n    /* Compact Row Mobile Overrides */\n    .compact-pay-row {\n        padding: 0.75rem;\n    }\n\n    .cp-avatar {\n        width: 32px;\n        height: 32px;\n    }\n\n    .cp-name {\n        font-size: 1rem;\n    }\n\n    .cp-pending {\n        font-size: 1.05rem;\n    }\n\n    .cp-meta {\n        font-size: 0.75rem;\n    }\n\n    .cp-right {\n        gap: 0.6rem;\n        margin-left: 0.5rem;\n    }\n\n    /* Hide text on mobile button to save space */\n    .remind-txt {\n        display: none;\n    }\n\n    .cp-notify-btn {\n        padding: 0.5rem;\n    }\n\n    .admin-modal-card {\n        padding: 2rem 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
